import { canAfford } from './money';

export const PURCHASE_BLOCK_REASONS = Object.freeze({
  INSUFFICIENT_BALANCE: 'insufficient_balance',
  INVALID_AMOUNT: 'invalid_amount',
  NOT_PRO: 'not_pro',
  SEAT_CAP: 'seat_cap',
  SEAT_BELOW_USED: 'seat_below_used',
  SUBMITTING: 'submitting',
  WALLET_SPEND_FROZEN: 'wallet_spend_frozen',
});

/**
 * Pre-submit gate: never call purchase API when blocked.
 * Returns { ok: true } or { ok: false, reason }.
 */
export const evaluatePurchaseGate = ({
  amountCents,
  balanceCents,
  submitting = false,
  requiresPro = false,
  isPro = false,
  targetSeatLimit = null,
  seatsUsed = 0,
  seatCap = null,
  walletSpendFrozen = false,
}) => {
  if (submitting) {
    return { ok: false, reason: PURCHASE_BLOCK_REASONS.SUBMITTING };
  }

  if (walletSpendFrozen) {
    return { ok: false, reason: PURCHASE_BLOCK_REASONS.WALLET_SPEND_FROZEN };
  }

  const amount = Number(amountCents);
  if (!Number.isFinite(amount) || amount < 0) {
    return { ok: false, reason: PURCHASE_BLOCK_REASONS.INVALID_AMOUNT };
  }

  if (requiresPro && !isPro) {
    return { ok: false, reason: PURCHASE_BLOCK_REASONS.NOT_PRO };
  }

  if (targetSeatLimit != null) {
    const limit = Number(targetSeatLimit);
    if (Number.isFinite(seatCap) && limit > seatCap) {
      return { ok: false, reason: PURCHASE_BLOCK_REASONS.SEAT_CAP };
    }
    if (limit < Number(seatsUsed || 0)) {
      return { ok: false, reason: PURCHASE_BLOCK_REASONS.SEAT_BELOW_USED };
    }
  }

  if (amount > 0 && !canAfford(balanceCents, amount)) {
    return { ok: false, reason: PURCHASE_BLOCK_REASONS.INSUFFICIENT_BALANCE };
  }

  return { ok: true };
};

export const mapApiError = (err, fallback = 'request_failed') => {
  const status = err?.response?.status;
  if (status === 403) return 'forbidden';
  if (status === 401) return 'unauthorized';
  const code = err?.response?.data?.code || err?.response?.data?.error;
  if (code === 'insufficient_wallet_balance') return 'insufficient_balance';
  if (code === 'wallet_spend_frozen') return 'wallet_spend_frozen';
  if (code === 'daily_topup_limit_exceeded') return 'daily_topup_limit_exceeded';
  if (code === 'stripe_not_configured') return 'stripe_not_configured';
  if (code) return String(code);
  if (!err?.response) return 'network_error';
  return fallback;
};
